import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconeDetalhePregao extends Component {
    render() {
        const isApregoado = this.props.apregoado;
        return (
            <Box
                sx={{
                    border: `2px solid #000`,
                    height: '14px',
                    width: '20px',
                    color: isApregoado ? '#FFF' : '#000',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontSize: '12px',
                    lineHeight: '12px',
                    borderRadius: '2px',
                    background: isApregoado ? '#000' : 'none',
                    fontWeight: 'bold'
                }}
            >
                P
            </Box>
        );
    }
}

IconeDetalhePregao.propTypes = {
    apregoado: PropTypes.bool
};

IconeDetalhePregao.defaultProps = {
    apregoado: false
};

export default IconeDetalhePregao;
